import { NotificationStatusWindowInfo, NotificationType } from '@/alert/utils/notification.types';

export const NOTIFICATION_STATUS_I18N_KEY: Record<NotificationType, string> = {
  email: 'WORD.EMAIL',
  slack: 'WORD.SLACK',
  telegram: 'WORD.TELEGRAM',
  sms: 'WORD.MESSAGING',
  webhook: 'WORD.WEBHOOK',
  kakaoTalk: 'WORD.KAKAOTALK',
  onSite: 'WORD.ON_SITE',
};
export const NOTIFICATION_ICON_KEY: Record<NotificationType, string> = {
  email: 'icon-color-message',
  slack: 'icon-color-slack',
  telegram: 'icon-color-telegram',
  sms: 'icon-color-sms',
  webhook: 'icon-color-webhook',
  kakaoTalk: 'icon-kakaotalk',
  onSite: 'icon-color-on-site',
};

export const NOTIFICATION_STATUS_WINDOW_I18N_KEY: Record<string, string> = {
  status: 'WORD.STATUS',
  sendTime: 'WORD.SEND_TIME',
  receivers: 'WORD.RECEIVER',
  notifiedChannel: 'WORD.NOTIFIED_CHANNEL',
  notifiedChat: 'WORD.NOTIFIED_CHAT',
  errorLog: 'WORD.ERROR_LOG',
  notifiedWebhook: 'WORD.NOTIFIED_WEBHOOK',
  response: 'WORD.RESPONSE',
  smsType: 'WORD.MESSAGING_TYPE',
  request: 'WORD.REQUEST2',
};

export const NOTIFICATION_STATUS_METHOD_BY_TYPE: Record<string, string> = {
  slack: 'notifiedChannel',
  telegram: 'notifiedChat',
  webhook: 'notifiedWebhook',
  onSite: 'receivers',
};

export const NOTIFICATION_STATUS_WINDOW_INITIAL_INFO: NotificationStatusWindowInfo = {
  isShow: false,
  availableStatus: [],
  selectedType: 'email',
  resultId: '',
};
